class collectionDiscoverWinesLoader {
  constructor() {
    this.container = document.querySelector('[data-collection-discover-wines-container]');
    this.loadMoreBtn = document.querySelector('[data-collection-discover-wines-cta]');

    if (this.loadMoreBtn) {
      this.currentPage = parseInt(this.loadMoreBtn.dataset.currentPage);
      this.perPage = parseInt(this.loadMoreBtn.dataset.perPage);
      this.totalItems = parseInt(this.loadMoreBtn.dataset.totalItems);
      this.setupEventListeners();
    }
  }

  setupEventListeners() {
    this.loadMoreBtn.addEventListener('click', () => this.loadMore());
  }

  loadMore() {
    const nextPage = this.currentPage + 1;
    const hiddenItems = this.container.querySelectorAll('.collection-discover-more-wines__link--hidden');

    hiddenItems.forEach((item, index) => {
      if (index < this.perPage) {
        item.classList.remove('collection-discover-more-wines__link--hidden');
      }
    });

    this.currentPage = nextPage;
    this.loadMoreBtn.dataset.currentPage = nextPage;

    if (this.currentPage * this.perPage >= Math.min(42, this.totalItems)) {
      this.loadMoreBtn.remove();
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new collectionDiscoverWinesLoader();
});
